<template>
  <section id="sec">

    <div class="api_notice" style="font-family: Arial, sans-serif; line-height: 1.6">
      <h2 style="margin-top: 0">制限・補足事項</h2>
      <div style=" font-size: 18px; font-weight: 700;">
        <u>APIリクエストの増加に伴う制限について</u>
      </div>

      <div style="font-size: 12px;">
        DirectCloud APIからのリクエストに対しては、テナントごとに以下の制限がかかります。<br>
        <ul>
          <li>ファイルアップロードでは、すべての契約プランで、1分間のリクエスト数が240に制限されます。</li>
          <li>APIリクエストでは、契約プランによって、1分間のリクエスト数が異なります。</li>
        </ul>
        <table class="notice-table">
          <thead>
          <tr>
            <th>スタンダード</th>
            <th>アドバンスド</th>
            <th>ビジネス</th>
            <th>プレミアム</th>
            <th>エンタープライズ</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>1,000</td>
            <td>1,000</td>
            <td>1,000</td>
            <td>2,000</td>
            <td>3,000</td>
          </tr>
          </tbody>
        </table>
      </div>

      <br>
      <div style="font-size: 18px; font-weight: 700;">
        <u>バージョンアップしたAPI「v2」のリファレンスについて</u>
      </div>

      <div style="font-size: 12px;">
        ダイレクトクラウドでは、本サイトで公開している「v1」のAPIのほかに、バージョンアップした「v2」のAPIを提供しています。<br>
        v2のAPIを利用する場合は、<a href="https://link.directcloud.jp/apireference" target="_blank" >こちら</a>にアクセスして、PDFファイルを参照してください。
        <ul>
          <li>「DirectCloud 電帳法対応」「DirectCloud AI」「変更されたノードの照会」などのAPIは、v2で提供しています。</li>
          <li>「ファイルダウンロード」「ファイルアップロード」「ファイルコピー」「ファイル移動」などのAPIは、v2でも提供を開始しています。</li>
          <li>そのほかのAPIについても順次v2に移行していく予定です。</li>
        </ul>
        注意：<br>
        全APIのv2移行が完了してから一定期間が経過すると、v1のAPIは利用できないようになります。<br>
        現時点でv2がリリースされているAPIについては、v2版をご利用いただきますようお願いいたします。
      </div>

      <br>
      <div style=" font-size: 18px; font-weight: 700;">
        <u>その他</u>
      </div>

      <div style="font-size: 12px;">
        <ul>
          <li>WebブラウザからDirectCloud APIを呼び出すことはできません。</li>
          <li>DirectCloud APIでは大文字と小文字が区別されますので、入力の際はご注意ください。</li>
          <li>
            本リファレンスに掲載されているAPIはDirectCloudで使用されているAPIの一部です。<br>
            お客さまからの要望で、今後DirectCloud APIの公開範囲を拡大する可能性があります。
          </li>
        </ul>
      </div>
    </div>

    <h1>ユーザー APIリファレンス</h1>
    <div class="container">
      <div v-for="tag of userXTags">
        <HomeList
          v-if="!modelsList.includes(tag)"
          :title="tag"
          :parsed="userParser(userDoc2, tag)"
          pilot="ユーザー"
        ></HomeList>
      </div>
    </div>

    <h1>管理者 APIリファレンス</h1>
    <div class="container">
      <div v-for="tag of managerTags">
        <HomeList
          :title="tag"
          :parsed="managerParser(managerDoc2, tag)"
          pilot="管理者"
        ></HomeList>
      </div>
    </div>
  </section>
</template>

<script>
// Components
import HomeList from '../components/HomeList';

// Functions
import { userParser, managerParser, getXTags, getTags } from '../data/userData';

export default {
  name: 'Home',
  components: {
    HomeList,
  },
  props: {
    userDoc2: Object,
    managerDoc2: Object,
  },
  data: function () {
    return {
      userXTags: getXTags(this.userDoc2),
      managerTags: getTags(this.managerDoc2),
      modelsList: this.userDoc2['x-tagGroups'].filter(
        (item) => item.name === 'Models',
      )[0].tags,
      qnaAfterHref: '/support/qna_after',
      qnaBeforeHref: '/support/qna_before',
    };
  },
  methods: {
    userParser,
    managerParser,
  },
};
</script>

<style scoped lang="scss">
h1 {
  text-align: center;
  margin: 2em 0 0.8em 0;
  font-size: 2.2rem;
  font-weight: 400;
  color: #151f26;
  line-height: 1.1;
  font-family: 'arial', 'Meiryo', 'MS PGothic', sans-serif !important;
}
.container {
  height: 100%;
  width: 100%;
  display: inline-grid;
  grid-template-columns: repeat(3, minmax(20%, 50%));
  //grid-auto-columns: minmax(10px, auto);
  grid-template-rows: repeat(2, minmax(auto, auto)); // rows 크기 자동조절
  //grid-auto-rows: minmax(20vh, auto);
  gap: 1.5rem;
  grid-auto-flow: dense;
}

.api_notice {
  margin-top: 20px;
}

.api_notice,
.api_plan {
  width: 1100px;
  border: 1px solid;
  border-radius: 10px;
  padding: 20px;
}

//.sec {
//  display: flex;
//  flex-wrap: wrap; // flex 일때 다음줄로 자연스럽게 넘어가게함
//}
</style>
